// extracted by mini-css-extract-plugin
export default {"Divider":"NQKakvcL","Vertical":"sktwVMLJ"};